import {UserProfile} from "@api/models/UserProfile";

/**
 * Checks if the given profile is in the given profiles list
 * @param list
 * @param profile
 */
export const isProfileInTheList = (list: UserProfile[], profile: UserProfile) => {
    return list.findIndex(item => item.userId == profile.userId) >= 0;
}
